const personality = {
	name: "Tomide Adeoye",
	businessName: "Meris Labs",
	job: "Software Engineer / Data Analyst",
	cta: { name: "Contact Me", link: "/contact-me" },
	contact: {
		email: "tomideadeoye@gmail.com",
		phone: "+2348181927251",
		businessMail: "tomideadeoye@gmail.com",
	},
	bio: {
		vision: "Changing Africa and the world one app at a time",
		short: `Hi. I am a software engineer and data analyst able to fit in business and engineering roles. I love to build companies solving real-world problems through software and data. I have 3+ years of experience in consulting, software, research, and academia. `,
		long: `A software engineer and data analyst able to fit in business and engineering roles. I am interested in building companies that solve real-world problems through software and data. I have 3+ years of experience in consulting, software, research, and academia. `,
		welcome: `Hi, 
			Welcome to my page. Adopting one of my favourite principles; the power of 10+, I have desigined my portfolio page to contain services, projects, papers and infographics to encourage a multiplicity of Activities on this website. You can find me talking about any of the following on this page:
		`,
		businessDescription: [
			`Meris Labs is a software and data company that helps businesses solve business problems. We are a team of software engineers, data analysts, and business analysts. We are passionate about building companies that solve real-world problems through software and data.`,
		],
		businessDescription2: `We leverage on effective communication strategies and contents in
		telling brand stories in a way that is relatable and impressionable in
		the hearts of their customers and prospects.`,
		businessImages: [],
	},

	location: {
		address: "House 3 Block C, Horizon 2 Extension Estate, Lekki",
		state: "Lagos",
		country: "Nigeria",
	},
	images: {
		professional:
			"https://pbs.twimg.com/profile_banners/802541689042849796/1605746236",
		casual: "https://github.com/tomideadeoye.png",
		logo: null,
	},
	socials: {
		linkedIn: {
			userName: "Tomide Adeoye",
			link: "https://www.linkedin.com/in/tomide-adeoye-828604129/",
		},
		github: {
			userName: "tomideadeoye",
			link: "https://github.com/tomideadeoye",
		},
		twitter: {
			userName: "_Tomide",
			link: "https://twitter.com/_Tomide",
		},

		instagram: {
			userName: "tomide_adeoye",
			link: "https://www.instagram.com/tomide_adeoye",
		},
		facebook: {
			userName: "_Tomide",
			link: "https://twitter.com/_Tomide",
		},
		youtube: {
			userName: "Tomide Adeoye",
			link: "https://www.youtube.com/channel/UCJDUei6y5gIyYHwwArC5DwQ",
		},
		website: {
			userName: "Tomide Adeoye",
			link: "https://tomide-adeoye.netlify.app/",
		},
		blog: {
			userName: "Tomide Adeoye",
			link: "https://www.tomideadeoye.com",
		},
		wikipedia: { link: "https://www.tomideadeoye.com" },
		calendly: { link: "www.calendly/tomideadeoye" },
	},
	offerings: ["Data Visualisation", "Web Development", "Build My Products"],
	experiences: {
		academic: [
			{
				name: "Postgraduate Certification in Tech, Entreprenureship and Mangement",
				position: "Nigerian University of Technology Management",
				date: "2021 – 2022",
				description: `
				•	One-year postgraduate Diploma in Technology and Management (Masters Equivalent)
				•	Courses: python programming, data analytics, business strategy, negotiation, products, and operations management.
				•	Started a company (VerifyPro) to implement the program’s entrepreneurial project. 
				`,
			},
			{
				name: "Python Data Analyst Certification",
				position: "Serenze Technology Program",
				date: "2021 – 2022",
				description: `
				•	One-year program in Data Analysis with Python and deployment of AI solutions in business contexts.  
				•	Acquired full-stack software engineering knowledge in React, NodeJS, and Flutter.
	`,
			},
			{
				name: "LL.B Law",
				position: "Obafemi Awolowo University",
				result: "Second Class Upper Division [2:1]",
				date: "2021 – 2022",
				description: `Studied subjects such as Contract Law and More.`,
			},
			{
				name: "Others",
				position: "",
				date: "2021 – 2022",
				description: `Cambridge A'Levels | Ascending College, WAEC | Our Lady and St. Francis College`,
				result: "A. A. C",
			},
		],
		work: [
			{
				name: "Dukka",
				position: "Software Engineer",
				date: "April. 2022 – present",
				description: `•	Built web interfaces and data visualizations for two company products (Dexter and Dash) with Material UI, D3js, and React JS to build web interfaces and company. 
				•	\n Implemented frontend designs of the company referral management system, Dexter, which has seen the acquisition of 10,000+ users and 100+ agents.
				•	Improved accuracy of company proprietary sales data from external feed ingestion by 40% through the implementation of React Query.
				•	Developed and enhanced UI components across the company site to visualize realized user signups.
				`,
			},
			{
				name: "Smart Contract Research Forumn",
				position: "Blockchain Researcher",
				date: "2018 - Present",
				description: `•	Reviewed Blockchain-focused research papers and proposals on Smart Contract Languages such as Solidity, business models of DeFi protocols, Ethereum vulnerabilities, and vulnerability countermeasures to Transaction Ordering Dependence and oracle manipulation attacks and more.
				•	Maintained and enhanced research data up to and including visualization in UI components.
				`,
			},
			{
				name: "General Business and Consulting Experience",
				position: "",
				date: "Oct. 2021 – present",
				description: `•	Previously worked in investment research and consulting capacities across organizations like KMPG, PwC, and Anchoria Asset Management.
				•	In those capacities, I reviewed startup investment proposals and helped create organizational management structures.
				`,
			},
		],
		volunteer: [
			{
				name: "Nigerian Univerisity of Technology and Management",
				position: "Programming Tutor ",
				date: "2021 – 2021",
				description: "Taught a focus group of 8 students python programming",
				links: [],
			},
			{
				name: "The Tax Club, OAU ",
				position: "President",
				date: "2017 – 2020",
				description: "Taught a focus group of 8 students python programming",
				tasks: [
					"Organized six tax seminars and partnered with KPMG for a community outreach",
				],
			},
		],
	},
	skills: [
		{ name: "Python", level: "Expert" },
		{ name: "Data Visualisation", level: "Expert" },
		{ name: "JavaScript", level: "Expert" },
		{ name: "React", level: "Expert" },
		{ name: "Dart", level: "Expert" },
		{ name: "Flutter", level: "Expert" },
		{ name: "Selenium", level: "Expert" },
		{ name: "Power BI", level: "Expert" },
		{ name: "Business Development", level: "Expert" },
	],
	interests: [
		{ name: "Blockchain", description: "Expert" },
		{ name: "Smart Contracts", description: "Expert" },
		{ name: "DeFi", description: "Expert" },
	],
	awards: [
		{
			company: "CFA Society",
			position: "OAU",
			date: "2018",
			description: "Winner: The CFA Ethics Challenge (2018)",
		},
		{
			company: "Finance Club OAU",
			position: "OAU",
			date: "2019",
			description:
				"1st Runner up The Bain and Company Pitch Case Competition (2019)",
		},
	],

	projects: [
		{
			name: "Dexter Referral System",
			position: "Software Engineer",
			date: "July 2022",
			description: "A dashboard and tracking tool for dukka salesforce program",
			tasks: [
				`Collaborated with a team of four engineers in building a dashboard for the company sales analysts.`,
				"Converted sales data to visualizations for UI components.",
			],
			links: {
				live: "https://dexter.dukka.com/",
				sourceCode: "https://dexter.dukka.com/",
			},
		},
		{
			name: "Unilever compliance web app ",
			position: "Software Engineer",
			date: "July 2022",
			description: "A Unilever Nigeria Plc. company-wide compliance project.",
			tasks: [
				`Worked in partnership with the Jackson, Etti, and Edu legal team to convert their reports into a web application. During the project, I converted several JSON files to UI components in Material-table.`,
			],
			links: {
				live: "https://unicomreport.netlify.app/",
				sourceCode: "https://unicomreport.netlify.app/",
			},
		},
		{
			name: "Verify Pro",
			position: "Software Engineer",
			date: "January 2022",
			description:
				"Geospatial Land Rights management system that maps documented property rights to GPS coordinates.",
			tasks: [
				`Managed a team of five in building a Geospatial Land Rights management system that maps documented property rights to GPS coordinates using React and firebase.`,
				`Engaged industry mentors to formulate strategies for product development.`,
				`Wrote web scraping python scripts to source data from property websites like PropertyPro.`,
			],
			links: {
				live: "https://verifypro.netlify.app/",
				sourceCode: "https://verifypro.netlify.app/",
			},
		},
		{
			name: "Paystack Data Analytics Project",
			date: "January 2022",
			description: "Product Specialist Presentation Exploratory Data Analysis",
			tasks: [
				`Combined presentation tools like PowerPoint and analytical tools like python in designing a presentation that calculates churn rate among other things.`,
			],
			links: {
				live: "https://drive.google.com/file/d/1XoSD6Fmrae6j0aiK7TXJnqWMguIB3NUl/view",
				sourceCode: "https://verifypro.netlify.app/",
			},
		},
		{
			name: "Dash",
			position: "Software Engineer",
			date: "July 2022",
			description:
				"Dash is part of the Dukka product offerings which all principally serve to build the bedrock for commerce in Africa.",
			tasks: [
				`Collaborated with a team of four engineers in building a dashboard for the company sales analysts.`,
				"Converted sales data to visualizations for UI components.",
			],
			links: {
				live: "https://dash-proto.netlify.app/",
				sourceCode: "https://github.com/tomideadeoye/dash-landing.git",
			},
		},

		{
			name: "General product design and management.",
			position: "Software Engineer",
			date: "January 2022",
			description:
				"A summation of other projects I have built in collaboration with different organsisations.",
			tasks: [
				`Wrote web scraping scripts in pythons to source funding opportunities for NGOs.`,
				`Redesigned and maintained an E-learning system for the Nigerian Institute of Chartered Arbitrators.`,
				`•	Created data visualizations and pitch decks for organizations such as 1504 restaurants, Jackson Etti and Edu, Hermes Advisory, and more .`,
			],
			links: {
				live: "https://drive.google.com/drive/folders/1Qvjwy_IqjjA25QFTtgZibquej20n0994?usp=sharing",
				sourceCode: "https://github.com/tomideadeoye/Scripts",
			},
		},
		{
			name: "JavaScript Games.",
			position: "Software Engineer",
			date: "January 2022",
			description: "Some JavaScript games I have enjoyed building.",
			tasks: "",
			links: {
				live: "https://tomidedicegame.netlify.app/",
				sourceCode: "https://github.com/tomideadeoye/Scripts",
			},
		},
		{
			name: "NodeJs/React Blog.",
			position: "Software Engineer",
			date: "January 2022",
			description: "",
			tasks: "",
			links: {
				live: "https://dips-blog.herokuapp.com/",
				sourceCode: "https://github.com/tomideadeoye/Scripts",
			},
		},
		{
			name: "Bootstrap Webisite",
			position: "Software Engineer",
			date: "January 2022",
			description: "",
			tasks: "",
			links: {
				live: "https://codepen.io/tdipfellows/pen/poaoaNx",
				sourceCode: "https://github.com/tomideadeoye/Scripts",
			},
		},
	],
	writings: [
		{
			name: "Investigating Arbitrageurs and Oracle Manipulators in Ethereum",
			date: "2020-01-01",
			description: `This paper provides an overview of the most significant security and privacy-related vulnerabilities that affected Ethereum-based smart contracts in 2021; Transaction Ordering Dependence and oracle manipulation.  
			Both vulnerabilities could lead to a significant loss of funds. However, transaction ordering dependence could also result in consensus-layer instability.`,
			link: "https://docs.google.com/document/d/1rM7EqUkjmW_LsuSG-dqrQ__2DZtNIofgwdeYUGz2UUQ/edit#heading=h.ikcr71959rtx",
			publishedLink: null,
			trackingLink: null,
		},

		{
			name: "A Formal Specification Smart-Contract Language for Legally Binding DAOS",
			date: "2020-01-01",
			description: `There are several advantages to adopting Blockchain in automating business operations. It makes inter-organizational information exchange easier, and all steps of the contracting processes, the search, negotiation, performance, adjudication, and commitment can be represented in smart contracts.
			But this is only possible when Smart Contract Languages built for legal and business constructs can formulate complex collaborative business contracts. 
			The paper describes a way of representing business contracts in a smart-legal-contract-markup language (SLCML) before conversion to a Smart Contract Language (SCL) like Solidity.
			`,
			link: `https://docs.google.com/document/d/1SYYAgfWyGBLzAKMZHnmjsQO1rQLbgCBGuCHot8UfKg8/edit#`,
			publishedLink: null,
		},

		{
			name: "A Short Survey on Business Models of Decentralized Finance (DeFi) Protocols.",
			date: "2020-01-01",
			description: `Protocols with efficient and observable business models are more likely to be “secure.” This paper explains the revenue stream of DeFi protocols to help investors and users understand the growth, sustainability, and security of different protocols.
			The authors discuss the business model of three DeFi protocol domains, abstract the general business model and identify key DeFi actors and actions.
			The authors conclude by asking research questions on subjects such as the valuation of similar governance tokens, the regulatory sustainability of DeFi business models, and 
			`,
			link: "https://docs.google.com/document/d/1pnwnYqMSw0y6o-g3uSQO2aR_RHn6EMfIQgTEN9Vevhs/edit",
			publishedLink:
				"https://www.smartcontractresearch.org/t/research-summary-a-short-survey-on-business-models-of-decentralized-finance-defi-protocols/1947",
		},
		{
			name: "A Source Code Based Taxonomy of Ethereum Smart Contracts",
			date: "2020-01-01",
			description: `Standard categorization of smart contract features could make development more accessible and limit vulnerabilities, particularly through the development of general purpose libraries and interfaces.
			The authors examined the source code of 150 smart contracts in 101 DApps. They found 28 dimensions with 64 characteristics for classification in six meta-categories. 
			The characteristics identified led them to identify 7 clusters for future research and standardisation of libraries.`,
			link: "https://docs.google.com/document/d/e/2PACX-1vTURhhYBo1XeEFZv8XOTwPWpYZrrXvaY-guDGsMVU8b_qbt6cBIZssKTb0xLKtUsRs9CmtovpMo87HL/pub?embedded=true",
			publishedLink: null,
		},
	],
	trainings: [
		{ name: "DIP Software Engineering Fellowship", link: "", description: "" },
		{ name: "(COMPTIA A+) Cisco Academy", link: "", description: "" },
		{ name: "CopyrightX Harvard Law School", link: "", description: "" },
		{
			name: "NUTM Python Programming and Data Analytics with PwC",
			link: "",
			description: "",
		},
	],

	project_todos: [
		{
			name: "SCRF",
			todos: [
				{ name: "Make SCRF data visualisation", urgent: true, important: true },
				{ name: "Arbitrageurs follow up", urgent: false, important: false },
				{ name: "Styling guide", urgent: false, important: false },
				{ name: "Finish current paper; BPMN", urgent: true, important: false },
			],
		},
		{
			name: "Dukka",
			todos: [
				{ name: "Dart tutorials", urgent: false, important: true },
				{ name: "Contact Elias", urgent: false, important: false },
				{ name: "Finish Merchant Anatomy", urgent: true, important: true },
				{ name: "Learn Django Courses", urgent: false, important: true },
			],
		},
		{
			name: "Law Schools",
			deadline: "2020-01-01",
			todos: [
				{
					name: "Figure out possibility of getting in",
					urgent: true,
					important: true,
				},
				{ name: "Apply to LLMs", urgent: true, important: true },
			],
		},
		{
			name: "Job Applications",
			deadline: "2020-01-01",
			todos: [
				{ name: "Paystack automation", urgent: true, important: true },
				{ name: "Job automations", urgent: true, important: true },
				{ name: "Contact Paul Zube", urgent: true, important: true },
				{
					name: "Contact Thomas Morpher and Ledger guy",
					urgent: true,
					important: true,
				},
				{
					name: "Use curated mailing list",
					urgent: true,
					important: true,
				},
				{
					name: "Contact Serenze mentors",
					urgent: true,
					important: true,
				},
				{
					name: "Contact Flashbots guy again",
					urgent: true,
					important: true,
				},
			],
		},
		{
			name: "Serenze",
			deadline: "2020-01-01",
			todos: [
				{ name: "Finish Data Analyst Path", urgent: true, important: true },
				{
					name: "Register certification exams",
					urgent: true,
					important: true,
				},
			],
		},
		{
			name: "Personal Projects",
			todos: [
				{ name: "Budgeting App", urgent: false, important: false },
				{ name: "Sis Blog", urgent: true, important: true },
				{ name: "Intimacy card game", urgent: false, important: false },
				{ name: "Harrapa Codification", urgent: false, important: true },
				{ name: "Quotes App", urgent: false, important: true },
				{ name: "Order Chair", urgent: false, important: true },
				{ name: "Johari Window App", urgent: false, important: true },
				{ name: "Work on Timi's blog", urgent: false, important: true },
				{ name: "Whatsapp check in app", urgent: false, important: true },
				{ name: "Youtube channel posts", urgent: false, important: true },
				{
					name: "publish all asignments as posts",
					urgent: false,
					important: false,
				},
				{
					name: "Join more communities and societies",
					urgent: false,
					important: false,
				},
				{
					name: "Set up wikipedia page",
					urgent: false,
					important: false,
				},
			],
		},
	],
	goals: [
		{
			name: "Patent Attorney",
			date: "2020-01-01",
			description: "xxxxxxxx",
			steps: ["Get LLM"],
		},
		{
			name: "Startup Tech Consulting",
			date: "2020-01-01",
			description: "xxxxxxxx",
			steps: ["Assemble Team"],
		},
	],
	gratitude: [
		{
			name: "SCRF Research Summary",
			date: "2020-01-01",
			description: "xxxxxxxx",
		},
		{
			name: "Finish Dart Courses",
			date: "2020-01-01",
			description: "xxxxxxxx",
		},
	],
	journaling: [
		{
			name: "SCRF Research Summary",
			date: "2020-01-01",
			description: "xxxxxxxx",
			private: true,
		},
		{
			name: "Finish Dart Courses",
			date: "2020-01-01",
			description: "xxxxxxxx",
			private: false,
		},
	],

	emails: {
		linkedIn: [
			`Hello Daniel,
		I am Tomide; a software engineerand a research @ SCRF. I have read several research papers referencing your work on MEV/TOD, I would love to work with you!!!!. 
		I look forward to connecting and discussing more.
		
		Cheers,
		Tomide
		https://tomide-adeoye.netlify.app/`,

			`I just thought to reach out to you in case any other engineering openings such as the one you previously referenced came up. 
		I am also building a software consultancy, and I will like to add you to my mailing list. If that work for you, please send me a preferred email address.`,
		],
	},
	frequentlyUsedLinks: [
		{
			link: "https://discord.com/channels/784234332617048065/788142033629741076",
			name: "SCRF Discord",
		},
		{
			link: "https://www.smartcontractresearch.org/",
			name: "SCRF Discord",
		},
		{
			link: "https://app.request.finance/",
			name: "Request Finance SCRF Payment",
		},
	],

	applyTo: [
		"pfp@paradigm.xyz",
		"thomas@morpher.com",
		"thomas.julien@ledger.fr",
		"vaishnavi.kalidindi@kaiko.com",
		"talent@nethermind.io",
		"aya@nethermind.io",
		"karthik@nethermind.io",
		"paul@scrf.io",
		"frances@chainsafe.io",
	],
	review: [{ link: "https://opensource.guide/", name: "Open Source Guide" }],
	blockchain_contacts: [
		["Gang Wan", "email.gang.wang@gmail.com"],
		["Haoyu Wang", "haoyuwang@bupt.edu.cn"],
	],
};

export default personality;

// very often the story of growth is not about finding gold but creating gold and convincing people to buy it.
// think of your career as a startup how do we accelerate it with technology
// on rare ocassions, we see the variable of the world for not what they are but what the truly represent

// app to design wedding outfits and contact tailor // app to design outfits and any tailor picks up design
// instagram merchant aggregator + sentiment analysis
// a service linking to all your social media accounts and creating a no code website for you instantly based on data available through webscriping
// law lecturers finding bot, connecting with them on linkedin, parse work expereinces and compose introductory message
// automated networking
// service helping lecturers draft better presentations (Zero design.com)
// service generating pitchbooks for startups based on questions asked
// Blockchain MEV searching
// complex collages.com

// auto join meeting bot/extension // generate emails for lead marketing
// reachout to all from MUTM with service offerings // scrape email bank // use new phone number for service offerings pitches
// set up youtube channel properly //paystack //propertyproscape //svg visualisation // react chart combo //defi /mev

// SCHEDULE
// 4AM - 6AM APPLICATIONS ================================================================
// Apply to ledger, paystack, morpher and others persistently - create a mailing list
// Reach CTOs personally
// Application to Blockchian Venture Capital Funds
// generate SOP bot // resume generator // service making automatic job applications and reconstructing the CV to match key words in the job description: form filler + linkedin/twitter opportunities crawler and auto apply
// LLMs scraping website same on tomide adeoye.com
// service making automatic job applications and reconstructing the CV to match key words in the job description: form filler + linkedin/twitter opportunities crawler and auto apply

// 6AM - 9AM SCRF ========================================================================
// rides: SCRF

// 8AM - 4PM LEARNING =====================================================================
// on post youtube tutorials, share with all on Nordic Devs // extract all whatsapp thingies
